export default "__VITE_ASSET__Cr99iAOp__"